import React, { useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { Tag } from './index'

import { FaTrash, FaPen } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { deletePost } from '../actions/posts'
import { getTags } from '../actions/tags'
import { getPlants } from '../actions/plants'
import { getPartners } from '../actions/partners'
// import { getPostTags } from '../actions/posts'

type PropsPost = {
  post?: any;
  id?: number;
  tag?: any;
  isDetails?: boolean;
  isForm?: boolean;
  setCurrentId?: any;
};

const Post: React.FC<PropsPost> = ({ setCurrentId, isForm = false, isDetails, post, tag }) => {
  
  const history = useHistory();
  
  const dispatch = useDispatch();

  // const tags = useSelector((state: any) => state.tags.map((tag) => tag._id))
  const postTag = useSelector((state: any) => state.tags.find(tag => tag._id === post.tags[0]))

  // const postPlant = useSelector((state: any) => state.plants.find(tag => tag._id === post.plants[0]))

  const postPlants = useSelector((state: any) => state.plants.filter(plant => post.plants.includes(plant._id)))

  const postPartners = useSelector((state: any) => state.partners.filter(partner => post.partners.includes(partner._id)))

  useEffect(() => {
    dispatch(getTags())
    dispatch(getPlants())
    dispatch(getPartners())
  }, [dispatch])

  const imageUrl = post.images ? post.images : '';

  // const heightForm = isForm ? 'auto' : '90px';

  const redirectDetailPost = () => {
    if (!isForm) {
      return history.push(`/detail/posts/${post._id}`)
    }
  }
  
  return (
    <div onClick={redirectDetailPost} draggable="true" className="_flex _flex-col _relative _rounded _w-full _mx-md _mb-sm" style={{ height: '200px', maxWidth: '500px' }}>
      <div className="_bg-darkengreen _rounded-t-card _bg-no-repeat _bg-cover _absolute _w-full _bg-center" style={{ height: '126px', backgroundImage: `url(${imageUrl})` }}>
        <div className="_d-flex _flex-col _p-sm _rounded-t-card background-brightness _h-full">
          <div className="_absolute _bottom-sm">
            {postTag && (
              <div className="_flex _flex-wrap">
                <Tag isForm={false} elements={postTag} />
              </div>
            )}
            <h1 className="_text-white">{post.title}</h1>
          </div>
        </div>
      </div>
      {isForm && (
        <div>
          <div className="_absolute _top-none _right-none _bg-white _rounded-card _py-xxs _px-sm _opacity-80">
            <button className="_text-black hover:_bg-gray-200 _rounded-card _p-xxs" type="button" onClick={() => setCurrentId(post._id)}>
              <FaPen />
            </button>
            <button className="_ml-xs _text-warning _p-xxs hover:_bg-gray-200 _rounded-card" type="button" onClick={() => dispatch(deletePost(post._id))}>
              <FaTrash />
            </button>
          </div>
          {postPartners.length > 0 && (
            <div className="_flex _flex-col _text-white _absolute _right-none _top-lg">
              <h3>Partenaires :</h3>
              <div className="_flex">
                {postPartners.map(element => (
                  <div className="_m-xs _bg-green _bg-no-repeat _bg-cover _bg-center _rounded-md" style={{ height: '40px', width: '40px', backgroundImage: `url(${element.image})` }} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <div className="_absolute _bg-white _rounded-md _w-full _shadow-card _p-sm _flex _flex-col _bottom-none" style={{ top: '110px',  minHeight: '90px' }}>
        <div className="_h-full">
          <span><strong> Objectifs</strong></span>  
          <p className="text-card">{post.goals}</p>
          {isForm && (
            postPlants.length > 0 && (
              <div className="_flex _flex-wrap _absolute _right-none _top-none">
                {postPlants.map(element => (
                  <Tag isPlant={true} isForm={false} elements={element} />
                ))}
              </div>
            )
          )}
          
        </div>
      </div>
    </div>
  );
};

export default Post;
